import Box from "@mui/material/Box";
import DocumentCard from "./DocumentCard";

const DocumentUploads = ({
	handleChange,
	passportUrl,
	passportFileSize,
	signatureUrl,
	signatureFileSize,
	identificationUrl,
	identificationFileSize,
}) => {
	return (
		<Box>
			<Box
				sx={{
					backgroundColor: "#fff",
					padding: "1.5rem",
				}}
			>
				<DocumentCard
					image={passportUrl}
					title="Passport Photograph"
					buttonText="upload passport"
					name="passport"
					fileSize={passportFileSize}
					handleChange={handleChange}
				/>
				<DocumentCard
					image={signatureUrl}
					title="Signature Specimen"
					buttonText="upload new signature"
					name="signature"
					fileSize={signatureFileSize}
					handleChange={handleChange}
				/>
				<DocumentCard
					image={identificationUrl}
					title="Identification Document"
					subtitle="Driver's License, Permanent Voter's Card and International Passport"
					buttonText="upload id"
					name="identificationDocument"
					fileSize={identificationFileSize}
					handleChange={handleChange}
				/>
			</Box>
		</Box>
	);
};

export default DocumentUploads;
